document.documentElement.classList.remove('no-js');

(() => {
  const root = window.Shopify?.routes?.root || '/';
  const drawer = document.querySelector('[data-maark-cart-drawer]');
  const overlay = document.querySelector('[data-maark-cart-overlay]');
  const drawerBody = document.querySelector('[data-maark-cart-body]');
  const drawerFoot = document.querySelector('[data-maark-cart-foot]');
  let lastFocus = null;

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[character]));
  const money = (cents, currency = 'EUR') => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency }).format(cents / 100);

  const openCart = () => {
    if (!drawer || !overlay) return;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-maark-cart-close]')?.focus();
  };
  const closeCart = () => {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.style.overflow = '';
    lastFocus?.focus?.();
  };
  const renderCart = cart => {
    document.querySelectorAll('[data-maark-cart-count]').forEach(node => node.textContent = cart.item_count);
    const label = document.querySelector('[data-maark-cart-label]');
    if (label) label.textContent = `${cart.item_count} article${cart.item_count > 1 ? 's' : ''}`;
    if (!drawerBody || !drawerFoot) return;
    if (!cart.items.length) {
      drawerBody.innerHTML = '<div class="maark-cart-drawer__empty"><span class="maark-brand__mark">M</span><h3>Votre sélection est vide.</h3><a href="/collections/all">Découvrir la collection</a></div>';
      drawerFoot.hidden = true;
      return;
    }
    drawerBody.innerHTML = cart.items.map(item => `<div class="maark-cart-drawer__item">
      ${item.image ? `<img src="${escapeHtml(item.image)}&width=180" alt="${escapeHtml(item.product_title)}" width="72" height="90">` : ''}
      <div><p>${escapeHtml(item.product_title)}</p><small>${escapeHtml(item.variant_title || '')} · Qté. ${item.quantity}</small>${Object.entries(item.properties || {}).filter(([key,value]) => value && !key.startsWith('_')).map(([key,value]) => `<div class="maark-cart-drawer__property"><b>${escapeHtml(key)} :</b> ${escapeHtml(value)}</div>`).join('')}<button type="button" data-maark-remove="${escapeHtml(item.key)}">Retirer</button></div>
      <strong>${money(item.final_line_price, cart.currency)}</strong></div>`).join('');
    drawerFoot.hidden = false;
    const total = drawerFoot.querySelector('[data-maark-cart-total]');
    if (total) total.textContent = money(cart.total_price, cart.currency);
  };
  const getCart = () => fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then(response => response.json());

  document.addEventListener('click', async event => {
    if (event.target.closest('[data-maark-cart-open]')) openCart();
    if (event.target.closest('[data-maark-cart-close]') || event.target === overlay) closeCart();
    const remove = event.target.closest('[data-maark-remove]');
    if (remove) {
      remove.disabled = true;
      try {
        const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: remove.dataset.maarkRemove, quantity: 0 }) });
        if (!response.ok) throw new Error('Cart update failed');
        renderCart(await response.json());
      } catch (error) { remove.disabled = false; }
    }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeCart(); });

  document.querySelectorAll('[data-maark-add-form], .maark-main-product__form, .dd-form, .dd-hoodie-form, .dd-new-product__form').forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const initial = button?.innerHTML;
    if (button) { button.disabled = true; button.textContent = 'Ajout…'; }
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Add failed');
      renderCart(await getCart());
      openCart();
    } catch (error) {
      HTMLFormElement.prototype.submit.call(form);
    } finally {
      if (button) { button.disabled = false; button.innerHTML = initial; }
    }
  }));

  const menuButton = document.querySelector('[data-maark-menu]');
  const menu = document.querySelector('.maark-nav');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.classList.toggle('is-open', open);
    menu?.classList.toggle('is-open', open);
  });

  document.querySelectorAll('[data-maark-filters]').forEach(filters => filters.addEventListener('click', event => {
    const button = event.target.closest('[data-filter]');
    if (!button) return;
    filters.querySelectorAll('button').forEach(item => item.classList.toggle('is-active', item === button));
    const grid = filters.closest('.maark-collection')?.querySelector('[data-maark-grid]');
    grid?.querySelectorAll('[data-maark-kind]').forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.maarkKind !== button.dataset.filter; });
  }));
})();
